import { render, staticRenderFns } from "./TalkMsg.vue?vue&type=template&id=565bfe76"
import script from "./TalkMsg.vue?vue&type=script&lang=js"
export * from "./TalkMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports